// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"f95084fc","453":"2e5845d0","732":"00c8a31b","977":"ba80f4e3"}[chunkId] + ".chunk.js");